export default __webpack_public_path__ + "static/media/auth-illustration-abstract-top.79b59cc9.png";